import * as types from "../../constants";

export function setPeriod(value) {
  return {
    type: types.PERIOD_SET,
    loadPeriod: value,
  };
}
